<template>
    <a-config-provider :theme="theme">
        <div
            :class="
                'epic-' +
                moduleStateLink +
                (grow_body ? ' h-screen' : '') +
                (moduleStateLink == 'cover' ? ' flex flex-col' : '')
            "
        >
            <template v-if="isEpicvaultEnabled">
                <div class="container">
                    <div class="absolute right-1 z-10">
                        <div class="float-right">
                            <epic-menu :module_state="isEpicvaultEnabled" />
                        </div>
                    </div>
                </div>

                <a-tabs
                    default-active-key="claim"
                    :active-key="currentNavLink"
                    type="card"
                    @change="onTabChange"
                    class="main-module-tabs"
                >
                    <a-tab-pane key="home" data-cy="home-tab">
                        <template #tab>
                            <span class="text-black">{{ $t('globals.navigation.main.dashboard') }}</span>
                        </template>
                    </a-tab-pane>
                    <a-tab-pane key="claim" data-cy="claim-tab" v-if="isClaimsVaultEnabled">
                        <template #tab>
                            <span class="text-black">Claims</span><span class="text-default-purple">Vault</span>
                        </template>
                    </a-tab-pane>
                    <a-tab-pane key="cover" data-cy="cover-tab" v-if="isCoverVaultEnabled">
                        <template #tab>
                            <span class="text-black">Cover</span><span class="text-default-blue-green">Vault</span>
                        </template>
                    </a-tab-pane>
                </a-tabs>
            </template>

            <navigation :home_link="home_link" />

            <template v-if="isEpicvaultEnabled">
                <div class="container mx-auto" :class="{ 'flex flex-col flex-1': grow_body }">
                    <slot></slot>
                </div>

                <epic-footer
                    v-if="show_footer"
                    :is_epicvault_enabled="isEpicvaultEnabled"
                    :state_link="moduleStateLink"
                />
            </template>
            <template v-else>
                <div class="claimsvault">
                    <div class="container mx-auto lg:pt-32 pt-24">
                        <slot></slot>
                    </div>

                    <epic-footer
                        v-if="show_footer"
                        :is_epicvault_enabled="isEpicvaultEnabled"
                        :state_link="moduleStateLink"
                    />
                </div>
            </template>
        </div>
    </a-config-provider>
</template>

<script>
import EpicMenu from '@/components/layout_sections/DropDownMenu.vue';
import Navigation from '@/components/layout_sections/Navigation.vue';
import EpicFooter from '@/components/layout_sections/Footer.vue';

import User from '@/models/user.js';

export default {
    components: {
        EpicMenu,
        Navigation,
        EpicFooter,
    },
    data() {
        return {
            theme: {
                token: {
                    fontFamily: 'sans-serif',
                },
            },
            display_notice: this.$store.state.system.display_notice,
            expiration_date: this.$store.state.user.is_multi_association_access
                ? this.$store.state.user.current_association.expiration_date
                : this.$store.state.user.association.expiration_date,
        };
    },
    watch: {
        expiration_date: {
            immediate: true,
            handler() {
                this.displayNotice();
            },
        },
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled ? true : false;
        },
        isClaimsVaultEnabled() {
            return this.$store.state.user.modules.claimsvault;
        },
        isCoverVaultEnabled() {
            return this.$store.state.user.modules.covervault;
        },
        currentNavLink() {
            return this.$store.state.navigation.current_link;
        },
        moduleStateLink() {
            return this.isEpicvaultEnabled ? this.currentNavLink : 'default';
        },
    },
    props: {
        show_footer: {
            type: Boolean,
            default: true,
        },
        grow_body: {
            type: Boolean,
            default: false,
        },
        home_link: {
            type: Object,
            default() {
                return {
                    to: (module = '') => {
                        if (this.isEpicvaultEnabled) {
                            switch (module) {
                                case 'home':
                                    this.$router.push({ name: 'home' }).catch(() => {});
                                    break;
                                case 'claim':
                                    this.$router.push({ name: 'home-claims' }).catch(() => {});
                                    break;
                                case 'cover':
                                    this.$router.push({ name: 'home-cover' }).catch(() => {});
                                    break;
                                default:
                                    this.$router.push({ name: 'home' }).catch(() => {});
                                    break;
                            }
                        } else {
                            this.$router.push({ name: 'home-claims' }).catch(() => {});
                        }
                    },
                    default: true,
                    module: null,
                };
            },
        },
    },
    methods: {
        displayNotice() {
            let expiration_date = this.$dayjs(this.expiration_date).endOf('day');
            let expires_in_days = expiration_date.diff(this.$dayjs().endOf('day'), 'days');
            let expires_in_hours = expiration_date.diff(this.$dayjs(), 'hours');
            let expires_in_minutes = this.$dayjs(this.expiration_date)
                .endOf('day')
                .diff(this.$dayjs().add(expires_in_hours, 'hours'), 'minutes');

            if (expires_in_days > 0 && expires_in_days <= 15 && !this.display_notice && User.can('view-company')) {
                this.$message.warning(
                    this.$t('globals.global.notifications.warning.association_expiration', {
                        days: expires_in_days,
                        date: expiration_date.format('dddd, MMMM Do YYYY'),
                    }),
                    0,
                );

                this.$store.dispatch('system/updateDisplayNotice', true);
            } else if (
                expires_in_days == 0 &&
                expires_in_hours > 1 &&
                !this.display_notice &&
                User.can('view-company')
            ) {
                this.$message.warning(
                    this.$t('globals.global.notifications.warning.association_expiration_today', {
                        hours: expires_in_hours,
                        minutes: expires_in_minutes,
                        date: expiration_date.format('dddd, MMMM Do YYYY'),
                    }),
                    0,
                );
                this.$store.dispatch('system/updateDisplayNotice', true);
            } else if (
                expiration_date <= this.$dayjs().endOf('day') &&
                !this.display_notice &&
                User.can('manage-users')
            ) {
                this.$message.warning(this.$t('globals.global.notifications.warning.association_expired'), 0);

                this.$store.dispatch('system/updateDisplayNotice', true);
            }
        },
        onTabChange(key) {
            switch (key) {
                case 'home':
                    this.$router.push({ name: 'home' }).catch(() => {});
                    break;
                case 'claim':
                    this.$router.push({ name: 'home-claims' }).catch(() => {});
                    break;
                case 'cover':
                    this.$router.push({ name: 'home-cover' }).catch(() => {});
                    break;
            }
        },
    },
};
</script>
